import { render, staticRenderFns } from "./Communities.vue?vue&type=template&id=70fcee2b&"
import script from "./Communities.vue?vue&type=script&lang=js&"
export * from "./Communities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70fcee2b')) {
      api.createRecord('70fcee2b', component.options)
    } else {
      api.reload('70fcee2b', component.options)
    }
    module.hot.accept("./Communities.vue?vue&type=template&id=70fcee2b&", function () {
      api.rerender('70fcee2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/Communities.vue"
export default component.exports